import { z } from 'zod';
import { CaseAnalysisSchema, ThemeJuridiqueSchema } from './legal-plan.js';

/**
 * Phase ③ LegalFrameAgent — enrichit la qualification ② par des fondements
 * juridiques vérifiés via Légifrance (articles VIGUEUR uniquement).
 *
 * **③ N'ÉLIMINE JAMAIS UN THÈME** (D29) : un thème sans fondement vérifié
 * survit avec `fondements: []`. C'est ④ qui décidera s'il est constructible.
 *
 * Voir hub doc § 4 ③ (`docs/architecture/plan-detaille-v2.md`).
 */

export const FondementSchema = z.object({
  code: z.string(),                                // ex: "Code civil"
  article: z.string(),                             // ex: "1231-1"
  contenu: z.string(),                             // texte intégral via legifrance_get_article
  etat: z.literal('VIGUEUR'),                      // FILTRÉ — D7
  version_en_vigueur_au: z.string().optional(),    // ISO date
}).strict();
export type Fondement = z.infer<typeof FondementSchema>;

export const ThemeJuridiqueEnrichiSchema = ThemeJuridiqueSchema.extend({
  fondements: z.array(FondementSchema),            // peut être vide (D29)
  fondements_raisonnement: z.string(),             // pourquoi ces articles
}).strict();
export type ThemeJuridiqueEnrichi = z.infer<typeof ThemeJuridiqueEnrichiSchema>;

export const QualificationEnrichieSchema = z.object({
  case_analysis: CaseAnalysisSchema,
  themes_juridiques: z.array(ThemeJuridiqueEnrichiSchema).min(1),
}).strict();
export type QualificationEnrichie = z.infer<typeof QualificationEnrichieSchema>;
